import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { ProjectProps } from 'src/@types/project';
import { fDate } from 'src/utils/formatTime';

type Props = {
  project: ProjectProps;
};

const ProjectDuration: React.FC<Props> = ({ project }) => {
  const { startDate, endDate } = project;

  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  //@ts-ignore
  const completion = Math.min(100, Math.round(((now - start) / (end - start)) * 100));

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="h4">Tidslinje</Typography>
      </Stack>
      <div>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" color="text.secondary">
            Oppstart
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ferdig
          </Typography>
        </Stack>
        <Box position="relative" zIndex={1}>
          <LinearProgress
            color={completion == 100 ? 'success' : 'warning'}
            variant="determinate"
            sx={{
              width: 1,
              height: (theme) => theme.spacing(5),
              position: 'absolute',
              top: 0,
              zIndex: -1,
            }}
            value={completion}
          />
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            py={1}
            px={2}
          >
            <Typography variant="body3" fontWeight="bold">
              {fDate(startDate, 'MMMM yyyy')}
            </Typography>
            <Typography variant="body3" fontWeight="bold">
              {fDate(endDate, 'MMMM yyyy')}
            </Typography>
          </Stack>
        </Box>
      </div>
    </Stack>
  );
};

export default ProjectDuration;
